import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Account, JoiAccount } from 'globals/store/accounts.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { adminAccountSelectionsReselector, clipboardAccountSelectionsReselector } from '../../store/reselectors/accounts.reselector';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { PhotoToggleCardComponent } from '../filters/photo-toggle-card.component';

@Component({
    selector: 'account-menu',
    templateUrl: 'account-menu.html',
    styleUrls: ['./account-menu.scss'],
    standalone: true,
    imports: [CommonModule, PhotoToggleCardComponent],
})
export class AccountMenuComponent extends Wrapper<AccountMenuComponent> implements OnInit {
  selectedAccount: JoiAccount
  accounts: JoiAccount[]
  @Input() isBudget = false
  @Input() unselectedAccountMessage = 'Please select an account to see its clipboard'
  @Output() openAccount: EventEmitter<JoiAccount> = new EventEmitter()

  ngOnInit( ){
    this.selectCallback<Account[], any>(this.isBudget ? adminAccountSelectionsReselector : clipboardAccountSelectionsReselector, null, accounts => {
      if (accounts?.length && !this.selectedAccount) {
        this.selectAccount(accounts[0])
      }
      this.accounts = jsonCopyObject(accounts)
    })
  }

  selectAccount(account: JoiAccount) {
    console.log("Selecting account", account)
    this.selectedAccount = account
    this.openAccount.emit(account)
  }

}

